








































































































































































































































































































































































































































































































































































































import Accordion from "@/components/shared/Accordion.vue";
import DecimalNumber from "@/components/shared/DecimalNumber.vue";
import ShipmentCostCalculateAddress from "@/components/shipments/ShipmentCostCalculate/ShipmentCostCalculateAddress.vue";
import date from "@/filters/DateFilter";
import datetime from "@/filters/DateTimeFilter";
import {
  TranslatedCountryDTO,
  OnlineMbePackTypeDef
} from "@/model/component.model";
import {
  AddressShipmentDTO,
  ConfigurationDTO,
  CountryDTO,
  MbeServiceDTO,
  SubcountryDTO,
  ZonosProformaDetailsDTO
} from "@/model/data.model";
import { ShipmentCalculateCostClass } from "@/model/ShipmentCalculateCostClass";
import { fieldSorter, isUk, translateErrorMessage } from "@/services/Helpers";
import { PriceListService } from "@/services/PriceListService";
import { Table } from "element-ui";
import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import { minValue } from "vuelidate/lib/validators";
import { AlertBus } from "@/plugins/alerts/AlertBus";
import { getTenantId } from "@/services/AuthService";
import { CustomerService } from "@/services/CustomerService";
import { ShipmentService } from "@/services/ShipmentService";
import { getKeyValueConfig } from "@/utils/fetchKeyValueConfigLevel";
import cc from "iso-currencies";
import CustomDutiesQuoteSection from "@/components/shipments/ShipmentCostCalculate/CustomDutiesQuoteSection.vue";
import { cloneDeep } from "lodash";

@Component({
  components: {
    CalculateAddress: ShipmentCostCalculateAddress,
    DecimalNumber,
    MbeAccordion: Accordion,
    CustomDutiesQuoteSection
  },
  validations() {
    return {
      shipmentCalculateCost: {
        shipmentPackages: {
          $each: {
            customerWeight: {
              minValue: minValue(0.1)
            }
          }
        },
        totalWeight: {
          minValue: minValue(0.1)
        }
      }
    };
  }
})
export default class ShipmentCostCalculate extends Vue {
  shipmentCalculateCost: ShipmentCalculateCostClass = null;
  countries: CountryDTO[] = [];
  storeZipCode = "";
  storeIsoCode = "";
  datePickerOptions = {
    disabledDate: (date: Date) => {
      const d = new Date();
      return date < new Date(d.getFullYear(), d.getMonth(), d.getDate());
    },
    firstDayOfWeek: 1
  };
  priceListService: PriceListService = null;
  calculateTable = null;
  shipAndPack = false;
  isETAMolEnabled = false;
  sv4bMin: number;
  sv4bMax: number;
  typeShipment = "DOM";
  allPackagesEqual = true;
  calculatedData: any = null;
  shipmentDirections: string[] = ["OUTBOUND", "INBOUND"];
  includeCustomDuties = false;
  zonosProformaDetails: ZonosProformaDetailsDTO[] = [];
  language = "";

  setZonosDetails(payload: {
    proformaDetails: ZonosProformaDetailsDTO[];
    language: string;
  }) {
    this.zonosProformaDetails = cloneDeep(payload.proformaDetails);
    this.language = payload.language;
  }

  get shouldDisplayDeliveryDateColumn() {
    return this.$store.getters["customer/config"].showTransitTime;
  }

  get etaFallbackActive() {
    return this.$store.getters["customer/config"].etaFallbackActive || false;
  }

  get countriesFrom() {
    return this.shipmentCalculateCost.addressTo.country.id ===
      this.shipmentCalculateCost.storeCountryId
      ? this.countries
      : [
          this.countries.find(
            item => item.id === this.shipmentCalculateCost.storeCountryId
          )
        ];
  }

  get countriesTo() {
    return this.shipmentCalculateCost.addressFrom.country.id ===
      this.shipmentCalculateCost.storeCountryId
      ? this.countries
      : [
          this.countries.find(
            item => item.id === this.shipmentCalculateCost.storeCountryId
          )
        ];
  }

  get showPricesWithSurchargesDetails() {
    return this.$store.getters["customer/config"]
      .showPricesWithSurchargesDetails;
  }

  get multiplePackages() {
    return this.$store.getters["customer/config"].multiplePackages;
  }

  created() {
    this.initETAMOLStatus();
    const withInbound = this.$store.getters.features.inbound;
    if (!withInbound) this.shipmentDirections = ["OUTBOUND"];
    const storeCountryId = this.$store.getters["customer/storeAddresses"][0]
      .countryId;
    const storeCountryName = this.$store.getters["customer/storeAddresses"][0]
      .countryName;
    const storeCity = this.$store.getters["customer/storeAddresses"][0].city;
    const storeProvince = this.$store.getters["customer/storeAddresses"][0]
      .province;

    const mbeCurrencySymbol = cc.information(this.$store.getters.currency)
      .symbol;
    this.shipmentCalculateCost = new ShipmentCalculateCostClass({
      mbeCurrencySymbol,
      storeCountryId
    });
    this.priceListService = new PriceListService();
    this.storeZipCode = this.$store.getters[
      "customer/storeAddresses"
    ][0].zipCode;
    this.storeIsoCode = this.$store.getters[
      "customer/storeAddresses"
    ][0].countryId;
    this.shipmentCalculateCost.addressFrom.country.id = storeCountryId;
    this.shipmentCalculateCost.addressFrom.country.name = storeCountryName;
    this.shipmentCalculateCost.addressFrom.zipCode = this.storeZipCode;
    this.shipmentCalculateCost.addressFrom.city = storeCity;
    this.shipmentCalculateCost.addressFrom.province = storeCity;
    this.shipmentCalculateCost.addressTo.country.id = storeCountryId;
    this.shipmentCalculateCost.addressTo.country.name = storeCountryName;
    this.loadCountries()
      .then(() => this.loadSubcountries("addressFrom"))
      .then(() => this.loadSubcountries("addressTo"))
      .then(() => this.loadMbeServices())
      .then(() => this.loadCourierPackageTypes())
      .then(() => this.loadExtraServices());
    ShipmentService.prototype
      .getKeysSV4B(
        "P",
        this.typeShipment,
        this.$store.getters["customer/info"].customerId
      )
      .then(res => {
        res.configurations.forEach(key => {
          if (
            key.confKey ===
            "SAFE_VALUE_4B_P_" + this.typeShipment + "_RANGE_1"
          )
            this.sv4bMin = parseFloat(key.confValue);
          if (
            key.confKey ===
            "SAFE_VALUE_4B_P_" + this.typeShipment + "_RANGE_2"
          )
            this.sv4bMax = parseFloat(key.confValue);
          if (
            key.confKey ===
            "SAFE_VALUE_4B_P_" + this.typeShipment + "_SHIP_PACK_COVERAGE"
          )
            this.shipAndPack = key.confValue === "true";
        });
      });
  }

  rowClicked(row) {
    (this.$refs.calculateTable as Table).toggleRowExpansion(row);
  }

  loadExtraServices() {
    return this.priceListService.getExtraServices().then(res => {
      const customerExtraServiceConfig = this.$store.getters[
        "customer/extraServiceConfig"
      ];
      this.shipmentCalculateCost.extraServices = res
        .filter(outer => {
          return (
            customerExtraServiceConfig.some(
              (inner: any) => outer.idMBEBusiness === inner.extraServiceId
            ) && outer.idMBEBusiness !== 0
          );
        })
        .map(item => {
          const extraServiceMaxValue = customerExtraServiceConfig.find(
            extra => extra.extraServiceId === item.idMBEBusiness
          )?.extraServiceMaxValue;
          return Object.assign(item, {
            active: false,
            extraServiceMaxValue: extraServiceMaxValue
              ? extraServiceMaxValue
              : 0,
            value: item.visibilityType.includes("VALUE") ? 0 : null
          });
        });
    });
  }

  loadMbeServices() {
    return PriceListService.getMbeServices().then((res: MbeServiceDTO[]) => {
      const visibilities = this.$store.getters[
        "customer/courierVisibilityConfig"
      ];
      const visible_services = visibilities.filter(
        (item: any) => item.courierServiceId === 0
      );
      const ShipmentTypes = {
        Domestic: "DOMESTIC",
        Import: "IMPORT",
        Export: "EXPORT"
      };
      this.shipmentCalculateCost.mbeServices = res
        .filter(outer => {
          return visible_services.some(
            inner => outer.idMBEService === inner.mbeServiceId
          );
        })
        .map(outer => {
          const domesticService = visible_services.some(
            inner =>
              outer.idMBEService === inner.mbeServiceId &&
              inner.shipmentType === ShipmentTypes.Domestic
          );
          const importService = visible_services.some(
            inner =>
              outer.idMBEService === inner.mbeServiceId &&
              inner.shipmentType === ShipmentTypes.Import
          );
          const exportService = visible_services.some(
            inner =>
              outer.idMBEService === inner.mbeServiceId &&
              inner.shipmentType === ShipmentTypes.Export
          );
          return Object.assign({}, outer, {
            shipmentType: {
              DOMESTIC: domesticService,
              IMPORT: importService,
              EXPORT: exportService
            }
          });
        });
    });
  }
  async initETAMOLStatus() {
    const obj = {
      tenantId: getTenantId(),
      multistoreId: null,
      storeId: null,
      confKey: "SYS_ACTIVATION_MOL_ETA"
    } as ConfigurationDTO;

    const response = await ShipmentService.prototype.getStoreKeys([obj]);
    this.isETAMolEnabled = getKeyValueConfig(
      response,
      "SYS_ACTIVATION_MOL_ETA"
    );
  }

  loadCountries() {
    return this.$store.cache
      .dispatch("cachemod/getCountries")
      .then((countries: CountryDTO[]) => {
        countries.sort((a: CountryDTO, b: CountryDTO) =>
          a.name < b.name ? -1 : 1
        );
        this.countries = countries
          .map(
            (country: CountryDTO): TranslatedCountryDTO => {
              const translatedCountry = {
                ...country
              } as TranslatedCountryDTO;
              translatedCountry.translatedName = this.$t(
                "country_" + country.id
              ).toString();
              return translatedCountry;
            }
          )
          .sort(fieldSorter(["translatedName"]));
      })
      .catch(() => {
        this.$snotify.error(this.$t("error_getting_countries").toString());
      });
  }

  loadSubcountries(addressDirection: string) {
    if (!this.shipmentCalculateCost[addressDirection].country.id) {
      return Promise.resolve();
    }
    return this.$store.cache
      .dispatch(
        "cachemod/getSubcountries",
        {
          countryId: this.shipmentCalculateCost[addressDirection].country.id,
          zipcode: this.shipmentCalculateCost[addressDirection].zipCode,
          storeZipCode: this.storeZipCode,
          storeIsoCode: this.storeIsoCode
        },
        { timeout: this.$store.state["cachemod"].timeouts.subCountries }
      )
      .then((res: SubcountryDTO[]) => {
        if (res) {
          this.shipmentCalculateCost[addressDirection].subcountries = res;
          this.shipmentCalculateCost[addressDirection].subcountry =
            res.length === 1 ? res[0] : null;
          if (
            this.shipmentCalculateCost["addressFrom"].country.id ===
            this.shipmentCalculateCost["addressTo"].country.id
          )
            this.typeShipment = "DOM";
          else this.typeShipment = "INT";
          ShipmentService.prototype
            .getKeysSV4B(
              "P",
              this.typeShipment,
              this.$store.getters["customer/info"].customerId
            )
            .then(res => {
              res.configurations.forEach(key => {
                if (
                  key.confKey ===
                  "SAFE_VALUE_4B_P_" + this.typeShipment + "_RANGE_1"
                )
                  this.sv4bMin = parseFloat(key.confValue);
                if (
                  key.confKey ===
                  "SAFE_VALUE_4B_P_" + this.typeShipment + "_RANGE_2"
                )
                  this.sv4bMax = parseFloat(key.confValue);
                if (
                  key.confKey ===
                  "SAFE_VALUE_4B_P_" + this.typeShipment + "_SHIP_PACK_COVERAGE"
                )
                  this.shipAndPack = key.confValue === "true";
              });
            });
        }
      })
      .catch(() =>
        this.$snotify.error(this.$t("error_getting_subcountries").toString())
      );
  }

  loadCourierPackageTypes() {
    return CustomerService.getCustomerPackTypes().then(res => {
      this.shipmentCalculateCost.packTypes = res.map(item => {
        const translatedMbePackageType = {
          ...item
        } as OnlineMbePackTypeDef;
        translatedMbePackageType.translatedPackTypeDescription = this.$t(
          "mbePackageType_" + item.packtypeBusinessId
        ).toString();
        return translatedMbePackageType;
      });
      if (
        this.shipmentCalculateCost.packTypes?.length > 0 &&
        !this.shipmentCalculateCost.packType.mbePackType
      ) {
        const packagePresel = this.shipmentCalculateCost.packTypes.find(
          value => value.packtypeBusinessId === 3
        );
        //preselect package or first available
        this.shipmentCalculateCost.packType = packagePresel
          ? packagePresel
          : this.shipmentCalculateCost.packTypes[0];
      }
    });
  }

  changeCountry(data) {
    this.shipmentCalculateCost[data.directionAddress].country.name =
      data.value.translatedName;
    this.shipmentCalculateCost[data.directionAddress].country.id =
      data.value.id;
    this.loadSubcountries(data.directionAddress);
    this.shipmentCalculateCost[data.directionAddress].zipCode = "";
    this.shipmentCalculateCost[data.directionAddress].city = "";
  }

  changeSubcountry(data) {
    this.shipmentCalculateCost[data.directionAddress].subcountry =
      data.value || "";
    if (!this.shipmentCalculateCost[data.directionAddress].country.id) {
      this.shipmentCalculateCost[data.directionAddress].subcountries = null;
    }
    if (data.value.length === 0) {
      this.loadSubcountries(data.directionAddress);
    }
  }

  changeCity(data) {
    this.shipmentCalculateCost[data.directionAddress].city = data.value;
  }

  changeZipCode(data) {
    this.shipmentCalculateCost[data.directionAddress].zipCode = data.value;
    if (this.shipmentCalculateCost[data.directionAddress].zipCode.length >= 3) {
      this.loadSubcountries(data.directionAddress);
    }
  }

  packageCountModified(value: number) {
    this.shipmentCalculateCost.packageCountModified(value);
    this.adjustPackages();
  }

  deletePackage(index: any) {
    const halfBeforeTheUnwantedElement = this.shipmentCalculateCost.shipmentPackages.slice(
      0,
      index
    );
    const halfAfterTheUnwantedElement = this.shipmentCalculateCost.shipmentPackages.slice(
      index + 1
    );
    this.shipmentCalculateCost.shipmentPackages = halfBeforeTheUnwantedElement.concat(
      halfAfterTheUnwantedElement
    );
    this.adjustPackages();
  }

  duplicatePackage(shipmentPackage: any) {
    const pack = JSON.parse(JSON.stringify(shipmentPackage));
    this.shipmentCalculateCost.shipmentPackages.push(pack);
    this.adjustPackages();
  }

  changeTotalShipmentWeight(value: number) {
    this.shipmentCalculateCost.shipmentPackages.forEach((item, index) => {
      item.customerWeight = index === 0 ? value : 0;
    });
  }

  setShipmentWeight() {
    this.shipmentCalculateCost.totalWeight = this.shipmentCalculateCost.getTotalWeight;
  }

  sv4bValueValidation(value) {
    if (value < this.sv4bMin || value > this.sv4bMax) return false;
    return true;
  }

  toggleExtraService(item) {
    const extraItem = this.shipmentCalculateCost.extraServices.find(
      extra => extra === item
    );
    extraItem.active = !extraItem.active;
    if (!extraItem.active && extraItem.value) {
      extraItem.value = 0;
    }
  }

  calculate() {
    this.calculateTable = [];
    const maxShipmentWeight = this.$store.getters["customer/config"]
      .maxShipmentWeight;
    const maxPackageWeight = this.$store.getters["customer/config"]
      .maxPackageWeight;
    const exceedData = this.shipmentCalculateCost.checkInputData({
      maxShipmentWeight,
      maxPackageWeight
    });
    if (Object.keys(exceedData).length > 0) {
      let message = "";
      Object.keys(exceedData).forEach(key => {
        message += `${String(this.$i18n.t(key))} ${exceedData[key][0]}  ${
          key.length > 1 ? String(this.$i18n.t(exceedData[key][1])) : ""
        }<br />`;
      });
      message += String(this.$i18n.t("check_entered_parameters_or_contact"));
      return AlertBus.$alerts.danger(message);
    }
    const customerMbeId = this.$store.getters["customer/customerMbeId"];
    const storeAddresses = this.$store.getters["customer/storeAddresses"];
    const storeName = this.$store.getters["customer/storeInfo"].store.multiStore
      .businessName;
    let addressStore;
    let storeZipCode;
    let storeCity;
    if (storeAddresses.length >= 1) {
      addressStore = AddressShipmentDTO.fromAddressDTO(
        storeAddresses[0],
        storeName,
        "",
        "NATIONAL",
        this.$store.getters["customer/storeInfo"].contactReferences
      );
      storeCity = addressStore.city;
      storeZipCode = addressStore.zipCode;
    }
    const data = this.shipmentCalculateCost.getPayload(
      customerMbeId,
      storeZipCode,
      storeCity
    );
    let badValues = false;
    data.inputSurcharges.forEach(extra => {
      if (extra.mbeBusinessId === 300) {
        data.useOtherExtraServiceAndShipmentAndExtraServiceValueForBase = this.shipAndPack;
        if (!this.sv4bValueValidation(parseFloat(extra.extraServiceValue))) {
          this.$alerts.danger(
            this.$i18n.t("SAFE_VALUE_4B_EXTRA_SERVICE_OUTSIDE_CUSTOM_RANGE", {
              currencySymbol: (this as any).mbeCurrencySymbol,
              minVal: (this as any).sv4bMin,
              maxVal: (this as any).sv4bMax
            })
          );
          badValues = true;
        }
      }
      if (extra.mbeBusinessId === 1) {
        data.useOtherExtraServiceAndShipmentAndExtraServiceValueForBase = true;
      }
    });

    if (!badValues) {
      if (
        this.showTaxDutyLogic &&
        this.zonosProformaDetails &&
        this.zonosProformaDetails.length > 0 &&
        this.language.length > 0
      ) {
        data.proformaDetails = cloneDeep(this.zonosProformaDetails);
        data.languageCode = this.language;
        data.customDutiesQuoteRequested = this.includeCustomDuties;
      }
      data.localStrategyActive = this.etaFallbackActive;
      this.calculatedData = JSON.parse(JSON.stringify(data));
      PriceListService.shipmentPriceCalculate(data)
        .then(res => {
          this.calculateTable = res.smartChoiceConsultationResultList
            .filter(item => item.totalNetPrice > 0 && item.shipmentPrice > 0)
            .map((item, index) => Object.assign({}, item, { index }));
        })
        .catch(err => {
          AlertBus.$alerts.danger(translateErrorMessage(err));
        });
    }
  }

  deliveryDate(row: any) {
    const { estimatedDeliveryDate, rateTimeVisible } = row;

    let displayedDeliveryDate = "N/A";
    if (estimatedDeliveryDate) {
      const shouldAddMissingMiliseconds =
        String(estimatedDeliveryDate).length < 13;
      //adding missing milliseconds (* 1000) for new Date()
      const milisecondsMultiplier = shouldAddMissingMiliseconds ? 1000 : 1;
      const newDate = String(
        new Date(parseInt(estimatedDeliveryDate) * milisecondsMultiplier)
      );
      displayedDeliveryDate = rateTimeVisible
        ? datetime(newDate)
        : date(newDate);
    }
    return displayedDeliveryDate;
  }

  isInsuranceConflict(definedExtraService: any) {
    if (definedExtraService.idMBEBusiness === 1) {
      return (
        this.isSelected({ idMBEBusiness: 300 }) ||
        this.isSelected({ idMBEBusiness: 3 })
      );
    }
    if (definedExtraService.idMBEBusiness === 3) {
      return (
        this.isSelected({ idMBEBusiness: 1 }) ||
        this.isSelected({ idMBEBusiness: 300 })
      );
    }
    if (definedExtraService.idMBEBusiness === 300) {
      return (
        this.isSelected({ idMBEBusiness: 3 }) ||
        this.isSelected({ idMBEBusiness: 1 })
      );
    }
    return false;
  }

  get showTaxDutyLogic() {
    return Boolean(
      this.shipmentCalculateCost &&
        this.shipmentCalculateCost.packType &&
        this.shipmentCalculateCost.addressFrom &&
        this.shipmentCalculateCost.addressTo &&
        this.shipmentCalculateCost.addressFrom.subcountry &&
        this.shipmentCalculateCost.addressTo.subcountry &&
        this.$store.getters.taxDutyEnabled &&
        this.isTaxDutyEnabled &&
        (!this.shipmentCalculateCost.addressFrom.subcountry.cee ||
          !this.shipmentCalculateCost.addressTo.subcountry.cee) &&
        [3, 4].includes(
          Number(this.shipmentCalculateCost.packType.packtypeBusinessId)
        )
    );
  }

  get isTaxDutyEnabled() {
    return this.$store.getters["customer/isTaxDutyEnabled"] as boolean;
  }

  @Watch("showTaxDutyLogic", { immediate: true })
  onShowTaxDutyLogicChange(status: boolean) {
    this.$store.commit("shipment/enableTaxDutySection", status);
  }

  isSelected(item: any): boolean {
    const extraItem = this.shipmentCalculateCost.extraServices.find(
      extra => extra.idMBEBusiness === item.idMBEBusiness
    );
    if (extraItem === undefined) return false;
    return extraItem.active;
  }

  shouldDisplayDeliveryDateTilde(displayedDeliveryDate: string, row: any) {
    return displayedDeliveryDate !== "N/A" && row.rateFromWebService === false;
  }

  changeShipmentWeight(value: any) {
    // Distribute entered weight in all packages
    const weight =
      typeof value === "number" ? value : parseFloat(value.replace(",", "."));
    const n = this.shipmentCalculateCost.shipmentPackages.length;
    const package_weight = weight / n;
    this.shipmentCalculateCost.shipmentPackages.forEach(item => {
      item.customerWeight = package_weight;
    });
    this.adjustPackages();
  }

  get isPackTypeEnvelope() {
    return this.shipmentCalculateCost.packType.packtypeBusinessId === 1;
  }

  @Watch("allPackagesEqual")
  adjustPackages() {
    if (this.allPackagesEqual) {
      this.shipmentCalculateCost.shipmentPackages.forEach((item: any) => {
        item.width = this.shipmentCalculateCost.shipmentPackages[0].width;
        item.height = this.shipmentCalculateCost.shipmentPackages[0].height;
        item.depth = this.shipmentCalculateCost.shipmentPackages[0].depth;
        item.customerWeight = this.shipmentCalculateCost.shipmentPackages[0].customerWeight;
      });
    }

    this.shipmentCalculateCost.totalWeight = this.shipmentCalculateCost.shipmentPackages
      .map(item => {
        return Number(item.customerWeight);
      })
      .reduce((a, b) => a + b, 0);
  }

  get notShowTotPrice() {
    return this.$store.getters["customer/config"].notShowTotalShipPrice;
  }

  open(row: any, shipmentDirection: string) {
    let query = {};
    if (shipmentDirection == "INBOUND") {
      query = {
        type: "inbound"
      };
    }
    const ship = ShipmentService.shipmentFromCalculate(
      row,
      this.calculatedData,
      this.shipmentCalculateCost,
      shipmentDirection == "INBOUND"
    );
    this.$router.push(
      {
        name: "NewShipment",
        params: { ship: JSON.stringify(ship), calculated: "calculated" },
        query
      },
      () => {},
      () => {
        this.$snotify.error("Shipment not found");
      }
    );
  }

  mbePackageModified() {
    if (this.shipmentCalculateCost.packType.packtypeBusinessId === 1) {
      this.allPackagesEqual = true;
      const val = 0.2; // fixed weight for envelope
      this.changeShipmentWeight(val);
    }
  }

  get uk() {
    return isUk();
  }
}
